import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Lightweight page-enter animation using CSS only, so the animation library
 * is no longer part of the first download on every visit.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="animate-page-in">
      {children}
    </div>
  );
}